"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PromotionPerformanceExportRowExtension_1 = require("./PromotionPerformanceExportRowExtension");

var PromotionPerformanceRowSupplierInfo_1 = require("./PromotionPerformanceRowSupplierInfo");
/**
 * Row of promotion performance report.
 * @author Radek Beran
 */


var PromotionPerformanceReportRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionPerformanceReportRowDTO, _DomainObject_1$Domai);

  /**
   * @param id unique internal id
   * @param nodeId Id based on origin entity
   * @param reportId
   * @param level
   * @param treeLevel
   * @param entity Name of origin entity ( eg. WindowItem.name)
   * @param isGroup Flag that says if entity have children
   * @param title Title based on origin entity ( eg. WindowItem.name )
   * @param promotionId promotion id
   * @param department
   * @param cd
   * @param scm
   * @param cm
   * @param category
   * @param category4box
   * @param windowOriginId
   * @param windowName
   * @param windowTypeId
   * @param windowTypeName
   * @param mergedWindowIds
   * @param windowItemId
   * @param productName
   * @param productId
   * @param supplierName
   * @param supplierId
   * @param startWeekDate
   * @param themeId
   * @param storeSpecification
   * @param posMechanics Window item pos Mechanics attribute.
   * @param skuCount
   * @param creditsEnabled
   * @param creditsAmountForPurchase
   * @param creditsHealthyAmountForPurchase
   * @param creditsPurchaseQuantity
   * @param regularPrice
   * @param promoPrice
   * @param promoPriceCount
   * @param promoDiscount
   * @param posMarginImpact
   * @param secondaryPlacementFee
   * @param leafletFee
   * @param fcApprovalNeeded
   * @param forecastRisk
   * @param isDummy Flag that says if entity is dummy
   * @param requestForSecondaryPlacement
   * @param secondaryPlacement
   * @param onPicture
   * @param numberOfSites
   * @param weeklySplit ratio for splitting item's promo volume into the week; in percent: 0, .., 100
   * @param supplierCurrency
   * @param promoPurchaseStartDate
   * @param promoPurchaseEndDate
   * @param costPriceFormat
   * @param promoPurchasePrice
   * @param promoPurchasePriceCZK
   * @param regularPurchasePrice
   * @param regularPurchasePriceCZK
   * @param promoPurchasePricePlus
   * @param promoPurchasePricePlusCZK
   * @param kpiSegmentationRealName
   * @param kpiSegmentationUserName
   * @param kpiSegmentationSystemName
   * @param kpiValues Kpi Values associated with report row.
   * @param simAttrs simulated attributes that were changed during simulation to another value;
   * should be highlighted in report; strings represent names of attributes of this DTO or names nested
   * within
   * @param exportExtension
   * @param logisticComment
   * @param unitBackDiscount
   * @param nonPreferredSupplierIncluded
   * @param supplierInfos {@link PromotionPerformanceRowSupplierInfo} information about suppliers
   * @param vatRate
   *
   */
  function PromotionPerformanceReportRowDTO(id, nodeId, reportId, level, treeLevel, isGroup, entity, title, promotionId, // 4Box
  department, cd, scm, cm, category, category4box, // lower levels
  windowOriginId, windowName, windowTypeId, windowTypeName, mergedWindowIds, windowItemId, productName, productId, supplierName, supplierId, startWeekDate, // other attributes
  themeId, storeSpecification, posMechanics, skuCount, creditsEnabled, creditsAmountForPurchase, creditsHealthyAmountForPurchase, creditsPurchaseQuantity, regularPrice, promoPrice, promoPriceCount, promoDiscount, posMarginImpact, secondaryPlacementFee, leafletFee, fcApprovalNeeded, forecastRisk, isDummy, // RFC-377
  requestForSecondaryPlacement, secondaryPlacement, onPicture, numberOfSites, weeklySplit, supplierCurrency, promoPurchaseStartDate, promoPurchaseEndDate, costPriceFormat, promoPurchasePrice, promoPurchasePriceCZK, regularPurchasePrice, regularPurchasePriceCZK, promoPurchasePricePlus, promoPurchasePricePlusCZK, // kpi
  kpiSegmentationRealName, kpiSegmentationUserName, kpiSegmentationSystemName, kpiValues, // RFC-370 (issue PROMO-5): Names of simulated attributes
  simAttrs, // Extended data for promotion performance export
  exportExtension, // PROMO-397
  logisticComment, unitBackDiscount,
  /** PROMO-463 - saved basic information about all suppliers */
  nonPreferredSupplierIncluded, supplierInfos, vatRate) {
    var _this;

    _classCallCheck(this, PromotionPerformanceReportRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceReportRowDTO).call(this));
    _this.id = id;
    _this.nodeId = nodeId;
    _this.reportId = reportId;
    _this.level = level;
    _this.treeLevel = treeLevel;
    _this.isGroup = isGroup;
    _this.entity = entity;
    _this.title = title;
    _this.promotionId = promotionId;
    _this.department = department;
    _this.cd = cd;
    _this.scm = scm;
    _this.cm = cm;
    _this.category = category;
    _this.category4box = category4box;
    _this.windowOriginId = windowOriginId;
    _this.windowName = windowName;
    _this.windowTypeId = windowTypeId;
    _this.windowTypeName = windowTypeName;
    _this.mergedWindowIds = mergedWindowIds;
    _this.windowItemId = windowItemId;
    _this.productName = productName;
    _this.productId = productId;
    _this.supplierName = supplierName;
    _this.supplierId = supplierId;
    _this.startWeekDate = startWeekDate;
    _this.themeId = themeId;
    _this.storeSpecification = storeSpecification;
    _this.posMechanics = posMechanics;
    _this.skuCount = skuCount;
    _this.creditsEnabled = creditsEnabled;
    _this.creditsAmountForPurchase = creditsAmountForPurchase;
    _this.creditsHealthyAmountForPurchase = creditsHealthyAmountForPurchase;
    _this.creditsPurchaseQuantity = creditsPurchaseQuantity;
    _this.regularPrice = regularPrice;
    _this.promoPrice = promoPrice;
    _this.promoPriceCount = promoPriceCount;
    _this.promoDiscount = promoDiscount;
    _this.posMarginImpact = posMarginImpact;
    _this.secondaryPlacementFee = secondaryPlacementFee;
    _this.leafletFee = leafletFee;
    _this.fcApprovalNeeded = fcApprovalNeeded;
    _this.forecastRisk = forecastRisk;
    _this.isDummy = isDummy;
    _this.requestForSecondaryPlacement = requestForSecondaryPlacement;
    _this.secondaryPlacement = secondaryPlacement;
    _this.onPicture = onPicture;
    _this.numberOfSites = numberOfSites;
    _this.weeklySplit = weeklySplit;
    _this.supplierCurrency = supplierCurrency;
    _this.promoPurchaseStartDate = promoPurchaseStartDate;
    _this.promoPurchaseEndDate = promoPurchaseEndDate;
    _this.costPriceFormat = costPriceFormat;
    _this.promoPurchasePrice = promoPurchasePrice;
    _this.promoPurchasePriceCZK = promoPurchasePriceCZK;
    _this.regularPurchasePrice = regularPurchasePrice;
    _this.regularPurchasePriceCZK = regularPurchasePriceCZK;
    _this.promoPurchasePricePlus = promoPurchasePricePlus;
    _this.promoPurchasePricePlusCZK = promoPurchasePricePlusCZK;
    _this.kpiSegmentationRealName = kpiSegmentationRealName;
    _this.kpiSegmentationUserName = kpiSegmentationUserName;
    _this.kpiSegmentationSystemName = kpiSegmentationSystemName;
    _this.kpiValues = kpiValues;
    _this.simAttrs = simAttrs;
    _this.exportExtension = exportExtension;
    _this.logisticComment = logisticComment;
    _this.unitBackDiscount = unitBackDiscount;
    _this.nonPreferredSupplierIncluded = nonPreferredSupplierIncluded;
    _this.supplierInfos = supplierInfos;
    _this.vatRate = vatRate;
    return _this;
  }
  /**
   * Returns external id of promotion performance row for export register (export to IDB).
   */


  _createClass(PromotionPerformanceReportRowDTO, [{
    key: "getExportExtRowId",
    value: function getExportExtRowId() {
      return this.entity + // e.g. Week (aggregation type)
      ':' + this.title + // e.g. 2021 02 (aggregation name)
      ':' + (this.exportExtension !== undefined ? this.exportExtension.promotion.externalId + ':' : '') + this.productId // GOLD ID + sales variant id
      ;
    } // LOG-7625 - use for merged windows only!
    // returns new DTO with some attributes hidden as required

  }, {
    key: "getMergedWindowDto",
    value: function getMergedWindowDto() {
      var _a; // list of KPIs we want to keep in merged Window


      var keepKPIs = ['PromoSalesUser', 'PromoSalesSystem', 'PromoSalesReal', 'PromoSalesDeltaUser', 'PromoSalesDeltaSystem', 'VolumeUser', 'VolumeSystem', 'VolumeReal', 'VolumeDeltaUser', 'VolumeDeltaSystem', 'BaselineSales', 'GrossMarginReal', 'GrossMarginSystem', 'GrossMarginUser', 'GrossMarginUserRel', 'GrossMarginSystemRel', 'GrossMarginRealRel', 'GrossMarginDeltaUserRel', 'GrossMarginDeltaSystemRel', 'GrossMarginBaseline', 'GrossMarginBaselineRel', 'VendorAllowanceUser', 'VendorAllowanceSystem', 'VendorAllowanceReal', 'VolumeLiftUser', 'VolumeLiftSystem', 'VolumeLiftReal', 'PromoSalesLiftUser', 'PromoSalesLiftSystem', 'PromoSalesLiftReal', 'BackDiscountUser', 'BackDiscountSystem', 'BackDiscountReal', 'BMProxyUser', 'BMProxySystem', 'BMProxyReal', 'BMProxyUserRel', 'BMProxySystemRel', 'BMProxyRealRel', 'BMProxyDeltaUserRel', 'BMProxyDeltaSystemRel'];
      var base = new PromotionPerformanceReportRowDTO(this.id, this.nodeId, this.reportId, this.level, this.treeLevel, this.isGroup, this.entity, this.title, this.promotionId);
      var filtered = (_a = this.kpiValues) === null || _a === void 0 ? void 0 : _a.filter(function (_val, key) {
        return keepKPIs.includes(key);
      });
      return base.copyMulti({
        windowName: this.windowName,
        windowTypeName: this.windowTypeName,
        startWeekDate: this.startWeekDate,
        storeSpecification: this.storeSpecification,
        regularPrice: this.regularPrice,
        vatRate: this.vatRate,
        promoPrice: this.promoPrice,
        promoDiscount: this.promoDiscount,
        mergedWindowIds: this.mergedWindowIds,
        exportExtension: this.exportExtension,
        simAttrs: this.simAttrs,
        kpiValues: filtered
      });
    }
  }]);

  return PromotionPerformanceReportRowDTO;
}(DomainObject_1.DomainObject);

exports.PromotionPerformanceReportRowDTO = PromotionPerformanceReportRowDTO;
/**
 * name of idb table as documented in
 * https://docs.google.com/spreadsheets/d/1URTwN7vy0uUbNfUBdVVFiD2nSGlDyJOFWNtl9zYz2BA/edit#gid=717431265
 */

PromotionPerformanceReportRowDTO.TABLE_NAME = 'promo_performance_logio';
PromotionPerformanceReportRowDTO.HEADERS_LEADING = immutable_1.List.of('aggregation_type', 'aggregation_name', 'promotion_id', 'promotion_name', 'promotion_valid_from', 'promotion_valid_to', 'promotion_gos', 'promotion_type', 'store_specification', 'promotion_workflow_state', 'window_name', 'window_type', 'window_workflow_state', 'window_start_week_date', 'window_start_week', 'fc_approval_needed', 'product_name', 'product_id', 'department', 'scm', 'cm', 'category', 'category4box', 'supplier_id', 'supplier_department_id', 'commercial_contract_id', 'supplier_name', 'supplier_currency', 'regular_price', 'promo_price', 'promo_discount', 'regular_purchase_price', 'regular_purchase_price_czk', 'promo_purchase_price', 'promo_purchase_price_czk', 'promo_purchase_price_plus', 'promo_purchase_price_plus_czk', 'promo_purchase_start_date', 'promo_purchase_end_date', 'cost_price_format', 'pos_margin_impact', 'pos_mechanics');
PromotionPerformanceReportRowDTO.HEADERS_MEMBER_CREDITS_ATTRIBUTES_OLD = immutable_1.List.of('extra_member_credits', 'member_credit_amount', 'member_credit_quantity');
PromotionPerformanceReportRowDTO.HEADERS_MEMBER_CREDITS_ATTRIBUTES = immutable_1.List.of('extra_loyalty_credits', 'member_credit_amount', 'healthy_credit_amount', 'product_quantity');
PromotionPerformanceReportRowDTO.HEADERS_TRAILING = immutable_1.List.of('leaflet_fee', 'secondary_placement_fee', 'req_for_secondary_placement', 'secondary_placement', 'on_picture', 'number_of_sites', 'weekly_split', 'promo_sales_real', 'promo_sales_user', 'promo_sales_system', 'promo_sales_delta_user', 'promo_sales_delta_system', 'volume_real', 'volume_user', 'volume_system', 'volume_delta_user', 'volume_delta_system', 'baseline_sales', 'gross_margin_real', 'gross_margin_user', 'gross_margin_system', 'gross_margin_real_rel', 'gross_margin_user_rel', 'gross_margin_system_rel', 'gross_margin_delta_user_rel', 'gross_margin_delta_system_rel', 'gross_margin_baseline', 'gross_margin_baseline_rel', 'forecast_accuracy_system', 'forecast_accuracy_user', 'forecast_cm', 'vendor_allowance_real', 'vendor_allowance_user', 'vendor_allowance_system', 'supplier_promo_contribution', 'volume_lift_real', 'volume_lift_user', 'volume_lift_system', 'promo_sales_lift_real', 'promo_sales_lift_user', 'promo_sales_lift_system', 'back_discount_real', 'back_discount_user', 'back_discount_system', 'bm_proxy_real', 'bm_proxy_user', 'bm_proxy_system', 'bm_proxy_real_rel', 'bm_proxy_user_rel', 'bm_proxy_system_rel', 'bm_proxy_delta_user_rel', 'bm_proxy_delta_system_rel', 'bm_increment_real', 'bm_increment_user', 'bm_increment_system', 'promo_sales_increment_real', 'promo_sales_increment_user', 'promo_sales_increment_system', 'bm_effective_increment_real', 'bm_effective_increment_user', 'bm_effective_increment_system', 'promo_sales_effect_inc_real', 'promo_sales_effect_inc_user', 'promo_sales_effect_inc_system', 'cherry_picking_receipts_rel', 'on_shelf_availability', 'overstock_value_before', 'overstock_value_after', 'overstock_value_delta', 'stock_value_before', 'stock_value_after', 'stock_volume_before', 'stock_volume_after', 'stock_value_delta', 'day_stock_left', 'segmentation_real', 'segmentation_user', 'segmentation_system', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'a10', 'a11', 'a12', 'a13', 'a14', 'a15', 'a16', 'a17', 'a18', 'a19', 'a20');
/**
 * CSV headers, including headers for member credits (with old names)
 */

PromotionPerformanceReportRowDTO.HEADERS_WITH_MEMBER_CREDITS_OLD = PromotionPerformanceReportRowDTO.HEADERS_LEADING.concat(PromotionPerformanceReportRowDTO.HEADERS_MEMBER_CREDITS_ATTRIBUTES_OLD).concat(PromotionPerformanceReportRowDTO.HEADERS_TRAILING);
/**
 * CSV headers, including headers for member credits (after implementation of PROMO-507 Promo4Healthy)
 */

PromotionPerformanceReportRowDTO.HEADERS_WITH_MEMBER_CREDITS = PromotionPerformanceReportRowDTO.HEADERS_LEADING.concat(PromotionPerformanceReportRowDTO.HEADERS_MEMBER_CREDITS_ATTRIBUTES).concat(PromotionPerformanceReportRowDTO.HEADERS_TRAILING);
PromotionPerformanceReportRowDTO.QUOTE_COLUMNS = {
  aggregation_type: true,
  aggregation_name: true,
  department: true,
  scm: true,
  cm: true,
  category: true,
  category4box: true,
  product_name: true,
  product_id: true,
  supplier_name: true,
  supplier_id: true,
  commercial_contract_id: true,
  supplier_currency: true,
  promotion_id: true,
  promotion_name: true,
  promotion_valid_from: true,
  promotion_valid_to: true,
  promotion_type: true,
  promotion_workflow_state: true,
  window_name: true,
  window_workflow_state: true,
  // fc_approval_needed: false,
  start_week_date: true,
  start_week: true,
  store_specification: true,
  pos_mechanics: true,
  // all prices: false
  promo_purchase_start_date: true,
  promo_purchase_end_date: true,
  secondary_placement: true
};

PromotionPerformanceReportRowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionPerformanceReportRowDTO.name);
  return {
    id: builder.str('id'),
    nodeId: builder.str('nodeId'),
    reportId: builder.str('reportId'),
    level: builder.num('level'),
    treeLevel: builder.num('treeLevel'),
    isGroup: builder.bool('isGroup'),
    entity: builder.opt(builder.str('entity')),
    title: builder.opt(builder.str('title')),
    promotionId: builder.opt(builder.str('promotionId')),
    department: builder.opt(builder.str('department')),
    cd: builder.opt(builder.str('cd')),
    scm: builder.opt(builder.str('scm')),
    cm: builder.opt(builder.str('cm')),
    category: builder.opt(builder.str('category')),
    category4box: builder.opt(builder.str('category4box')),
    windowOriginId: builder.opt(builder.str('windowOriginId')),
    windowName: builder.opt(builder.str('windowName')),
    windowTypeId: builder.opt(builder.str('windowTypeId')),
    windowTypeName: builder.opt(builder.str('windowTypeName')),
    mergedWindowIds: builder.opt(builder.listOf(builder.id('mergedWindowIds'))),
    windowItemId: builder.opt(builder.str('windowItemId')),
    productName: builder.opt(builder.str('productName')),
    productId: builder.opt(builder.str('productId')),
    supplierName: builder.opt(builder.str('supplierName')),
    supplierId: builder.opt(builder.str('supplierId')),
    startWeekDate: builder.opt(builder.date('startWeekDate')),
    themeId: builder.opt(builder.str('themeId')),
    storeSpecification: builder.opt(builder.str('storeSpecification')),
    posMechanics: builder.opt(builder.str('posMechanics')),
    skuCount: builder.opt(builder.num('skuCount')),
    creditsEnabled: builder.opt(builder.bool('creditsEnabled')),
    creditsAmountForPurchase: builder.opt(builder.num('creditsAmountForPurchase')),
    creditsHealthyAmountForPurchase: builder.opt(builder.num('creditsHealthyAmountForPurchase')),
    creditsPurchaseQuantity: builder.opt(builder.num('creditsPurchaseQuantity')),
    regularPrice: builder.opt(builder.bigNum('regularPrice')),
    promoPrice: builder.opt(builder.bigNum('promoPrice')),
    promoPriceCount: builder.opt(builder.num('promoPriceCount')),
    promoDiscount: builder.opt(builder.bigNum('promoDiscount')),
    posMarginImpact: builder.opt(builder.bigNum('posMarginImpact')),
    secondaryPlacementFee: builder.opt(builder.bigNum('secondaryPlacementFee')),
    leafletFee: builder.opt(builder.bigNum('leafletFee')),
    fcApprovalNeeded: builder.opt(builder.bool('fcApprovalNeeded')),
    forecastRisk: builder.opt(builder.bool('forecastRisk')),
    isDummy: builder.opt(builder.bool('isDummy')),
    //RFC-377
    requestForSecondaryPlacement: builder.opt(builder.bool('requestForSecondaryPlacement')),
    secondaryPlacement: builder.opt(builder.str('secondaryPlacement')),
    onPicture: builder.opt(builder.bool('onPicture')),
    numberOfSites: builder.opt(builder.num('numberOfSites')),
    weeklySplit: builder.opt(builder.bigNum('weeklySplit')),
    supplierCurrency: builder.opt(builder.str('supplierCurrency')),
    promoPurchaseStartDate: builder.opt(builder.date('promoPurchaseStartDate')),
    promoPurchaseEndDate: builder.opt(builder.date('promoPurchaseEndDate')),
    costPriceFormat: builder.opt(builder.str('costPriceFormat')),
    promoPurchasePrice: builder.opt(builder.bigNum('promoPurchasePrice')),
    promoPurchasePriceCZK: builder.opt(builder.bigNum('promoPurchasePriceCZK')),
    regularPurchasePrice: builder.opt(builder.bigNum('regularPurchasePrice')),
    regularPurchasePriceCZK: builder.opt(builder.bigNum('regularPurchasePriceCZK')),
    promoPurchasePricePlus: builder.opt(builder.bigNum('promoPurchasePricePlus')),
    promoPurchasePricePlusCZK: builder.opt(builder.bigNum('promoPurchasePricePlusCZK')),
    // KPI
    kpiSegmentationRealName: builder.opt(builder.str('kpiSegmentationRealName')),
    kpiSegmentationUserName: builder.opt(builder.str('kpiSegmentationUserName')),
    kpiSegmentationSystemName: builder.opt(builder.str('kpiSegmentationSystemName')),
    kpiValues: builder.opt(builder.smap(builder.bigNum('kpiValues'))),
    simAttrs: builder.opt(builder.listOf(builder.str('simAttrs'))),
    exportExtension: builder.opt(builder.obj('exportExtension', PromotionPerformanceExportRowExtension_1.PromotionPerformanceExportRowExtension.schema, function (mat) {
      return PromotionPerformanceExportRowExtension_1.PromotionPerformanceExportRowExtension.fromMat(mat);
    })),
    logisticComment: builder.opt(builder.str('logisticComment')),
    unitBackDiscount: builder.opt(builder.bigNum('unitBackDiscount')),
    nonPreferredSupplierIncluded: builder.opt(builder.bool('nonPreferredSupplierIncluded')),
    supplierInfos: builder.opt(builder.listOf(builder.obj('supplierInfos', PromotionPerformanceRowSupplierInfo_1.PromotionPerformanceRowSupplierInfo.schema, function (mat) {
      return PromotionPerformanceRowSupplierInfo_1.PromotionPerformanceRowSupplierInfo.fromDataDict(mat);
    }))),
    vatRate: builder.opt(builder.bigNum('vatRate'))
  };
}();